import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: [],
  country: [],
  city: [],
  isLoading: false,
  error: null,
  isLoadingCountries: false,
  isLoadingDestination: false,
  destinationCities: [],
  errorDestination: null,

  cityPortsOrigin: [],
  cityPortsDestination: [],
  isLoadingCityPortsOrigin: false,
  isLoadingCityPortsDestination: false,
  errorCityPortsOrigin: null,
  errorCityPortsDestination: null,

  provincesByCountryId: [],
  errorProvincesByCountryId: false,
  isLoadingProvincesByCountryId: false,

  cityByProvinceId: [],
  errorCityByProvinceId: false,
  isLoadingCityByProvinceId: false,

  districtByCityId: [],
  errorDistrictByCityId: false,
  isLoadingDistrictByCityId: false,

  subdistrictByDistrictId: [],
  errorSubdistrictByDistrictId: false,
  isLoadingSubdistrictByDistrictId: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/city/index.js